import api from './api';

export const getUnreadMentions = () => api.get('/mentions/unread').then(r => r.data);
export const markMentionRead   = (id) => api.post(`/mentions/${id}/read`).then(r => r.data);
export const markAllMentionsRead = () => api.post('/mentions/mark-all-read').then(r => r.data);
export const searchMentionableMembers = (q) => api.get('/mentions/search-members', { params: { q } }).then(r => r.data.members);
